// extracted by mini-css-extract-plugin
export default {"RightMenu":"RightMenu_RightMenu__k4CBI"};